import styled from 'styled-components';

const StyledFormContainer = styled.div`
  margin-top: 2rem;
  text-align: left;
`;

export default StyledFormContainer;
